import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../hooks/users/queries';
import { isCancelled, isOwner } from '../../utils/subscriptionUtils';

function SubscriptionRedirectComponent() {
    const history = useHistory();
    const { data: subscription } = useSubscription();
    const { data: currentUser } = useCurrentUser();

    useEffect(() => {
        if (subscription && currentUser) {
            
            if (!subscription) {
                return; // No subscription, don't redirect
            }
            
            if (isCancelled(subscription)) {
                if (isOwner(subscription, currentUser.id)) {
                    history.push('/users');
                }
                // If not owner and cancelled, don't redirect (stay on current page)
            } else {
                // Active subscription, redirect to welcome
                history.push('/welcome');
            }
        }
    }, [subscription, currentUser, history]);

    return <></>;
}

export default SubscriptionRedirectComponent;